import { datadogLogs } from '@datadog/browser-logs';
import eventQueue from '../queue';
var state = {
    skipErrorCodes: new Set(),
};
function attachEventListener() {
    eventQueue.on('state', function (_a) {
        var payload = _a.payload, action = _a.action, fireClientEvent = _a.fireClientEvent;
        if (action !== 'error/setError')
            return;
        var meta = {
            experimentMeta: {
                skipped: Array.from(state.skipErrorCodes),
                payload: payload,
            },
        };
        // Skip firing error code if the incoming error is blacklisted
        if (state.skipErrorCodes.has(payload.code)) {
            datadogLogs.logger.info('exp_cash_creds skipping_invalid_creds_error', meta);
            return;
        }
        datadogLogs.logger.info('exp_cash_creds firing_error', meta);
        fireClientEvent('error', payload);
    });
}
attachEventListener();
export function setErrorCodesToSkip(code) {
    state.skipErrorCodes.add(code);
}
